var map = {
	"./avatar_default.png": "05fe",
	"./banner1.png": "629f",
	"./bg-success.png": "6ec3",
	"./bg.png": "ca29",
	"./bg_r.png": "87f2",
	"./bottom_bg.png": "896e",
	"./btn-bg.png": "7fff",
	"./btn.png": "3285",
	"./btn2.png": "f98f",
	"./code.jpg": "8ca4",
	"./kv.png": "2584",
	"./kv05.png": "ef52",
	"./kv_slogan.png": "3af3",
	"./live_icon.png": "40bf",
	"./login_bg.png": "8e16",
	"./logo.png": "2e23",
	"./m_top.png": "e175",
	"./p1.png": "abdc",
	"./p2.png": "7fe2",
	"./p3.png": "c080",
	"./p4.png": "68b5",
	"./p5.png": "0c42",
	"./radio1.png": "5ec3",
	"./slogan.png": "e364",
	"./slogan01.png": "937c",
	"./tab-bg-active.png": "3869",
	"./tab-bg.png": "52cd",
	"./zzs01.png": "db2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7a7";